/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Box, Typography } from "@mui/material";


const loaderStyle = css`
  font-size: 1rem;
  display: flex;
  gap: 0.2rem;
`;

const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

const Spinner = ({ elapsedTime }) => (
    <Box display="flex" alignItems="center" css={loaderStyle}>
      <Box position="relative" width={40} height={40} mr={1}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #137d00',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" fontSize="10px" color="textSecondary">
            {formatTime(elapsedTime)}
          </Typography>
        </Box>
      </Box>
  
      <Box display="flex" alignItems="center">
        <Typography variant="body2">Generating</Typography>
        <Box component="span" sx={{ animation: 'blink 1.2s infinite 0s' }}>.</Box>
        <Box component="span" sx={{ animation: 'blink 1.2s infinite 0.3s' }}>.</Box>
        <Box component="span" sx={{ animation: 'blink 1.2s infinite 0.6s' }}>.</Box>
      </Box>
    </Box>
  );

  export default Spinner;